import React from 'react';
import { ImageState } from '../../../../types/properties/propertyTypes';
import Tooltip from '../../../../muiComponents/Tooltip';
import Image from '../../../components/Image';
import Icon from '../../../../muiComponents/Icon';

interface ImageCardProps {
    image: ImageState;
    onDelete: (id: string) => void;
    onToggleFeatured?: (id: string, bool: boolean) => void;
    onToggle360?: (id: string) => void;
    isToolbarVisible?: boolean;
    isDeleteButtonVisible?: boolean;
}

const ImageCard = (props: ImageCardProps) => {
    const {
        image,
        onDelete,
        onToggleFeatured,
        onToggle360,
        isToolbarVisible = true,
        isDeleteButtonVisible = true,
    } = props;
    const { caption, url, feature, is360 } = image;
    return (
        <div className='flex-column gap-5 height100perc'>
            <Tooltip title={caption}>
                <span className='height100perc'>
                    <Image
                        className='completed-presentation__image'
                        src={url || ''}
                        useLocalBaseUrl={false}
                    />
                </span>
            </Tooltip>
            <div
                className={`flex ${
                    isToolbarVisible ? 'flex-between' : 'flex-end'
                } align-items-center width100perc`}
            >
                {isToolbarVisible ? (
                    <div className='flex gap-10'>
                        <Tooltip
                            titleText={
                                feature ? 'fav_image_active' : 'fav_image'
                            }
                        >
                            <span>
                                <Icon
                                    iconName={feature ? 'Star' : 'StarOutline'}
                                    className={`property-image__icon${
                                        feature ? '--selected' : ''
                                    }`}
                                    onClick={() =>
                                        onToggleFeatured &&
                                        onToggleFeatured(image.id, !feature)
                                    }
                                />
                            </span>
                        </Tooltip>
                        <Tooltip
                            titleText={
                                is360
                                    ? 'panorama_image_active'
                                    : 'panorama_image'
                            }
                        >
                            <span>
                                <Icon
                                    iconName='ViewInAr'
                                    className={`property-image__icon${
                                        is360 ? '--selected' : ''
                                    }`}
                                    onClick={() => {
                                        onToggle360 && onToggle360(image.id);
                                    }}
                                />
                            </span>
                        </Tooltip>
                    </div>
                ) : null}
                {isDeleteButtonVisible ? (
                    <Tooltip titleText={`delete`}>
                        <span>
                            <Icon
                                iconName='Delete'
                                className={`property-image__icon --delete`}
                                onClick={() => onDelete(image.id)}
                            />
                        </span>
                    </Tooltip>
                ) : null}
            </div>
        </div>
    );
};

export default ImageCard;
